/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext } from 'react';

import type { SearchCategoriesProps, SearchResultsProps } from './types';

// Context for SearchCategories slot
export const SearchCategoriesContext = createContext<Partial<SearchCategoriesProps<any>>>({});

// Context for SearchResults slot
export const SearchResultsContext = createContext<Partial<SearchResultsProps<any>>>({});
